import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState, useEffect } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const MobileUserTable = ({
    mobileUsers,
    roles,
    onUserDeleted,
    onEdit,
    nearbyToggle,
    setNearbyToggle,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    entriesPerPage,
    setEntriesPerPage,
    locationError,
}) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    const [loading, setLoading] = useState(false);
    const [showLocationErrorModal, setShowLocationErrorModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (nearbyToggle && locationError) {
            setShowLocationErrorModal(true);
        }
    }, [nearbyToggle, locationError]);

    const headerConfig = [
        { key: "id", label: "User ID", sortable: false },
        { key: "created_at", label: "Created Date", sortable: false },
        { key: "updated_at", label: "Updated At", sortable: false },
        { key: "avatar", label: "Profile", sortable: false },
        { key: "name", label: "User Name", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "facebook_id", label: "Facebook ID", sortable: false },
        { key: "google_id", label: "Google ID", sortable: false },
        // { key: "latitude", label: "Latitude", sortable: false },
        // { key: "longitude", label: "Longitude", sortable: false }
        { key: "location", label: "Location", sortable: false }
    ];

    const handleDelete = async (userId) => {
        try {
            setLoading(true);
            await api.delete(`/mobileUsers/${userId}`);
            toast.success("User deleted successfully!");
            if (onUserDeleted) onUserDeleted(userId);
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error("Failed to delete user: " + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };
    const showDeleteConfirm = (userId) => {
        confirm({
            title: 'Are you sure you want to delete?',
            okText: 'Yes',
            okType: 'primary',
            cancelText: 'No',
            centered: true,
            onOk() { handleDelete(userId); },
        });
    };

    if (loading) return <ContentLoader />;
    console.log("mobileuser=======>,", mobileUsers);

    return (
        <>
            <Modal
                title="Location Permission Required"
                open={showLocationErrorModal}
                onOk={() => setShowLocationErrorModal(false)}
                onCancel={() => {
                    setShowLocationErrorModal(false);
                    setNearbyToggle(false);
                }}
                okText="OK"
                cancelText="Go Back"
                centered
            >
                <p>Location permission is required to view nearby users. Please enable location access in your browser settings.</p>
            </Modal>
            <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header responsive-header d-flex justify-content-between align-items-center global-header">
                <div className="tabs-container">
                    <Tabs
                        activeKey={nearbyToggle ? "nearby_users" : "all_users"}
                        onChange={(key) => {
                            if (key === "nearby_users") {
                                setNearbyToggle(true);
                            } else {
                                setNearbyToggle(false);
                            }
                            setPage(1); // reset pagination if needed
                        }}
                        items={[
                            { key: "all_users", label: "All Users" },
                            { key: "nearby_users", label: "Nearby Users" }
                        ]}
                    />
                </div>
                {/* <button
                    type="button"
                    className={`btn ${nearbyToggle ? "btn-success" : "btn-outline-secondary"}`}
                    onClick={() => setNearbyToggle(!nearbyToggle)}
                >
                    <Icon
                        icon={nearbyToggle ? "mdi:toggle-switch" : "mdi:toggle-switch-off"}
                        width="32"
                    />
                </button> */}

                <SearchBy
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                    }}
                />
            </div>
            <div className="card-body card-body-modify">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                        <thead>
                            <tr>
                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                            </tr>
                        </thead>
                        <tbody>
                            {nearbyToggle && locationError ? (
                                <tr>
                                    <td colSpan={9} className="text-center text-danger">
                                        Location permission denied
                                    </td>
                                </tr>
                            ) : Array.isArray(mobileUsers) && mobileUsers.length > 0 ? (
                                mobileUsers.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.id || ""}</td>
                                        <td>
                                            {user.created_at
                                                ? `${formatDateToDMY(user.created_at)} ${formatTime12Hour(user.created_at)}`
                                                : ""}
                                        </td>
                                        <td>
                                            {user.updated_at
                                                ? `${formatDateToDMY(user.updated_at)} ${formatTime12Hour(user.updated_at)}`
                                                : ""}
                                        </td>
                                        <td>
                                            <ImagePreviewModal
                                                src={user.avatar || "/assets/images/logo-profile.png"}
                                                fallback="/assets/images/logo-profile.png"
                                                alt={user.name}
                                                thumbWidth={50}
                                                thumbHeight={50}
                                            />
                                        </td>
                                        <td>{user.name || ""}</td>
                                        <td>{user.email || ""}</td>
                                        <td>{user.facebook_id || "-"}</td>
                                        <td>{user.google_id || ""}</td>
                                        <td>
                                            {user?.latitude != null && user?.longitude != null ? (
                                                <a
                                                    href={`https://www.google.com/maps/search/?api=1&query=${user.latitude},${user.longitude}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Icon icon="logos:google-maps" width="24" height="24" />
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className="text-center">
                                        No mobileUsers found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                />
            </div>
            </div>
        </>
    );
};

export default MobileUserTable;